module.exports = __webpack_public_path__ + "static/media/GF-logo.9e7e6590.svg";